export const priceWSymbolItem = (price: number) => {
  if (price >= 0) {
    return `¥${price}`;
  } else {
    return `-¥${Math.abs(price)}`;
  }
};
